<template>
  <Icon
    name="add"
    :width="24.92"
    :height="24.92"
  >
    <path
      d="M12.46,0A12.46,12.46,0,1,0,24.92,12.46,12.5,12.5,0,0,0,12.46,0Zm0,22.428a9.968,9.968,0,1,1,9.968-9.968A10,10,0,0,1,12.46,22.428Z"
      :fill="fill"
    ></path>
    <path
      d="M159.23,156.738V153h-2.492v3.738H153v2.492h3.738v3.738h2.492V159.23h3.738v-2.492Z"
      transform="translate(-145.524 -145.524)"
      :fill="fill"
    ></path>
  </Icon>
</template>

<script>
import iconMixin from "./iconMixin";

export default {
  name: 'Add',
  mixins: [iconMixin]
}
</script>
